import { MdErrorOutline } from "react-icons/md";

export default function ErrorBox({
  title = "Something went wrong",
  message,
  onRetry,
}) {
  const canRetry = typeof onRetry == "function";
  return (
    <div className="mx-auto max-w-md flex flex-col items-center gap-0 text-gray-700 text-center">
      <MdErrorOutline className="text-2xl text-red-800" />
      {title && <p className="text-lg">{title}</p>}

      {message && <p className="text-sm">{message}</p>}

      {canRetry && (
        <button
          onClick={onRetry}
          className="mt-4 text-sm bg-surface hover:bg-gray-200 transition-color duration-250 text-black rounded-md px-4 py-2 cursor-pointer "
        >
          Retry
        </button>
      )}
    </div>
  );
}
